import styled from "styled-components";

export const ReLoginBackground = styled.div`
  background-color: ${({ $bgColor }) => $bgColor || "white"};
  display: flex;
  height: 100%;
  flex-direction: column;

  transition: background-color 0.4s ease; /* ✅ 부드럽게 전환 */
`;

export const ReLoginHeader = styled.div`
  position: fixed; /* ✅ 화면 상단에 고정 */
  top: 0;
  z-index: 15;
  display: flex;
  width: 100%;
  align-items: center;
  background-color: white;
  padding: 20px 30px;
  justify-content: space-between;
  border-bottom: 1px solid rgba(166, 173, 185, 0.6);
  overflow-x: hidden;
  @media (max-width: 550px) {
    padding: 20px 10px;
  }
`;

export const HeaderButton = styled.button`
  display: flex;
  padding: 10px 16px;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: 36px;
  font-weight: 800;
  border: none;
  font-size: 20px;
  background-color: #f5a207;
  margin-right: 10px;

  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #f9b535;
    /* color: white; */
    color: black;
  }

  @media (max-width: 700px) {
    font-size: 10px;
    height: 40px;
    font-size: 16px;
    padding: 10px 10px;
  }
`;

export const HeaderButton2 = styled.button`
  display: flex;
  padding: 10px 16px;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: 36px;
  font-weight: 800;
  border: none;
  background-color: white;
  margin-right: 10px;
  font-size: 20px;

  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: white;
    /* color: white; */
    color: black;
  }

  @media (max-width: 700px) {
    font-size: 10px;
    height: 40px;
    font-size: 16px;
    padding: 10px 10px;
  }
`;

export const HeaderButton2Ko = styled.button`
  display: flex;
  padding: 10px 16px;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: 36px;
  font-weight: 800;
  border: none;
  background-color: white;
  margin-right: 10px;
  font-size: 20px;
  font-weight: 700;

  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: white;
    /* color: white; */
    color: black;
  }

  @media (max-width: 430px) {
    font-size: 10px;
    height: 40px;
    padding: 10px 10px;
  }
`;

export const HeaderLogoIconBox = styled.div`
  width: 50px;
  margin-right: 10px;

  @media (max-width: 430px) {
    width: 30px;
  }
`;
export const HeaderLogoIconBox2 = styled.div`
  width: 150px;

  @media (max-width: 430px) {
    width: 100px;
  }
`;
export const ReLoginBodyBox = styled.div`
  display: flex;
  padding: 20px 10%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
  @media (max-width: 700px) {
    padding: 20px 10%;
  }
`;

export const ReLoginTextOneBox = styled.div`
  z-index: 11;
  margin-top: 20px;
  font-size: 20px;
  min-width: 800px;
  word-break: keep-all;
  white-space: normal;
  overflow-wrap: break-word;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 24px;
  padding: 0px 20%;

  @media (max-width: 1200px) {
    min-width: auto;
  }
`;

export const ReLoginBodyGuideBox = styled.div`
  background-color: white;
`;

export const ReLoginTopBody = styled.div`
  position: relative;
  display: flex;

  /* margin-top: 50px; */
  flex-direction: column;
  height: 85vh;
  justify-content: center;
  align-items: center;

  @media (max-width: 500px) {
    /* height: 45vh; */
    min-width: auto;
  }
  @media (max-width: 376px) {
    height: 40vh;
    min-width: auto;
    margin-bottom: 120px;
  }
`;

export const ReLoginSideImage = styled.div`
  position: fixed;

  top: ${({ $top }) => $top || "10%"};
  left: ${({ $left }) => ($left !== undefined ? $left : "auto")};
  right: ${({ $right }) => ($right !== undefined ? $right : "auto")};
  z-index: 10;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  /* border: 1px solid rgba(166, 173, 185, 0.3); */
  border-radius: 16px;
  text-align: center;
  /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1); */

  transform: ${({ rotate, $visible }) =>
    $visible
      ? `rotate(${rotate || 0}deg) translateY(0)`
      : `rotate(${rotate || 0}deg) translateY(-20px)`};

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};

  transition: left 0.2s ease-out, right 0.2s ease-out, opacity 0.5s ease,
    transform 0.5s ease;
`;

export const ReLoginTopText = styled.div`
  z-index: 11;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 82px;
  font-weight: 800;
  text-align: center;
  word-break: keep-all;
  white-space: normal;
  overflow-wrap: break-word;
  color: #000;
  text-shadow: -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff,
    2px 2px 0 #fff;

  margin-top: 0px;

  @media (max-width: 1200px) {
    font-size: 78px;
  }

  @media (max-width: 900px) {
    font-size: 70px;
  }

  @media (max-width: 720px) {
    font-size: 44px;
  }

  @media (max-width: 400px) {
    font-size: 32px;
    margin-top: 200px;
  }
`;

export const ReLoginSubTitle = styled.span`
  z-index: 11;
  color: black;
  font-size: 24px;
  white-space: nowrap; // 줄바꿈 강제로 막기
  /* min-width: 1200px; */
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
    1px 1px 0 #fff;

  @media (max-width: 1100px) {
    white-space: normal;
    font-size: 24px;
  }

  @media (max-width: 900px) {
    white-space: normal;

    font-size: 22px;
  }

  @media (max-width: 700px) {
    font-size: 18px;
    white-space: normal;
  }

  @media (max-width: 630px) {
    white-space: normal;
    width: 400px;
    font-size: 18px;
  }

  @media (max-width: 550px) {
    white-space: normal;
    width: 380px;
    font-size: 18px;
  }

  @media (max-width: 470px) {
    white-space: normal;
    font-size: 16px;

    width: 250px;
  }
`;

export const ReLoginSubTitleKo = styled.span`
  z-index: 11;
  color: black;
  font-size: 24px;
  white-space: nowrap; // 줄바꿈 강제로 막기
  min-width: 800px;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
    1px 1px 0 #fff;

  @media (max-width: 1200px) {
    white-space: normal;
    font-size: 22px;
  }

  @media (max-width: 1100px) {
    white-space: normal;
    min-width: auto;
    font-size: 18px;
  }

  @media (max-width: 900px) {
    white-space: normal;

    font-size: 16px;
  }

  @media (max-width: 720px) {
    font-size: 14px;
    white-space: normal;
  }

  @media (max-width: 630px) {
    white-space: normal;

    font-size: 12px;
  }

  @media (max-width: 550px) {
    white-space: normal;

    font-size: 10px;
  }

  @media (max-width: 470px) {
    white-space: normal;

    font-size: 8px;
  }
`;

export const MakeButton = styled.button`
  background-color: #f5a207;
  padding: 10px 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 36px;
  font-weight: 800;
  font-size: 24px;
  height: 74px;
  /* margin-bottom: 10vh; */
  margin-top: 40px;

  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #f9b535;
    color: white;
  }

  @media (max-width: 700px) {
    height: auto;
    padding: 10px 20px;
    font-size: 20px;
  }
`;

export const MakeButtonKo = styled.button`
  background-color: #f5a207;
  padding: 10px 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 36px;
  font-weight: 800;
  font-size: 24px;
  height: 74px;
  /* margin-bottom: 10vh; */
  margin-top: 40px;

  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: #f9b535;
    color: white;
  }

  @media (max-width: 500px) {
    height: auto;
    padding: 10px 20px;
    font-size: 20px;
  }
`;

export const LoginSignUpButton = styled.button`
  background-color: ${({ $bgColor }) => $bgColor || "#ffdd04"};
  padding: 10px 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 36px;
  font-weight: 800;
  font-size: 24px;
  height: 74px;
  width: 100%;
  margin-bottom: 20px;
  max-width: 500px;
  /* margin-bottom: 10vh; */

  word-break: keep-all;
  white-space: normal;
  overflow-wrap: break-word;

  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: ${({ $hoverBgColor }) => $hoverBgColor || "#ffaa77"};
    color: white;
  }

  @media (max-width: 700px) {
    font-size: 14px;
  }

  /* @media (max-width: 550px) {
    font-size: 18px;
  }
  @media (max-width: 450px) {
    font-size: 16px;
  } */

  @media (max-width: 410px) {
    font-size: 12px;
    height: 50px;
  }
`;

export const LoginSignUpButton2 = styled.button`
  background-color: ${({ $bgColor }) => $bgColor || "#ffdd04"};
  padding: 10px 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 36px;
  font-weight: 800;
  font-size: 24px;
  /* height: 74px; */
  /* width: 100%; */
  margin-bottom: 20px;
  max-width: 500px;
  /* margin-bottom: 10vh; */

  word-break: keep-all;
  white-space: normal;
  overflow-wrap: break-word;

  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: ${({ $hoverBgColor }) => $hoverBgColor || "#ffaa77"};
    color: white;
  }

  @media (max-width: 700px) {
    font-size: 14px;
  }

  /* @media (max-width: 550px) {
    font-size: 18px;
  }
  @media (max-width: 450px) {
    font-size: 16px;
  } */

  @media (max-width: 410px) {
    font-size: 14px;
    height: 50px;
  }
`;

export const ReLoginContent = styled.div`
  background-color: white;
  color: #cb912f;
  border-radius: 36px;
  padding: 50px;
  margin-bottom: 42px;
  width: 100%;
  word-break: keep-all;
  white-space: normal;
  overflow-wrap: break-word;

  @media (max-width: 1100px) {
    padding: 30px 30px;
  }

  @media (max-width: 768px) {
  }

  @media (max-width: 576px) {
  }

  @media (max-width: 420px) {
  }

  @media (max-width: 360px) {
  }
`;

export const ReLoginContent2 = styled.div`
  background-color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: black;
  border-radius: 0px;
  padding: 50px;
  margin-bottom: 42px;
  width: 100%;
  word-break: keep-all;
  white-space: normal;
  overflow-wrap: break-word;

  @media (max-width: 1100px) {
    padding: 30px 30px;
  }

  @media (max-width: 768px) {
  }

  @media (max-width: 576px) {
  }

  @media (max-width: 420px) {
  }

  @media (max-width: 360px) {
  }
`;

export const ReLoginContentTitle = styled.div`
  font-weight: 800;
  font-size: 26px;
  margin-bottom: 40px;

  @media (max-width: 1100px) {
    font-size: 20px;
    margin-bottom: 23px;
  }

  @media (max-width: 700px) {
    font-size: 20px;
  }
`;

export const ResponsiveSpan = styled.div`
  font-weight: 600;
  font-size: 24px;
  text-decoration: ${({ underline }) => (underline ? "underline" : "none")};
  /* line-height: 0.5; */
  text-decoration-color: #a6adb9;
  @media (max-width: 1100px) {
    font-size: 22px;
  }

  @media (max-width: 700px) {
    font-size: 18px;
  }
`;

export const ResponsiveSpan2 = styled.div`
  font-weight: 800;
  font-size: 18px;
  /* line-height: 0.5; */

  @media (max-width: 1024px) {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
  }

  @media (max-width: 576px) {
    font-size: 8px;
  }

  @media (max-width: 420px) {
    font-size: 6px;
  }

  @media (max-width: 360px) {
    font-size: 6px;
  }
`;

export const ReLoginFlexBox = styled.div`
  display: flex;

  ${({ $justify }) => $justify && `justify-content: ${$justify};`}
  ${({ $align }) => $align && `align-items: ${$align};`}
  ${({ $width }) => $width && `width: ${$width};`}
`;

export const ReLoginFlexBox2 = styled.div`
  display: flex;

  ${({ $justify }) => $justify && `justify-content: ${$justify};`}
  ${({ $align }) => $align && `align-items: ${$align};`}
  ${({ $width }) => $width && `width: ${$width};`}

  @media (max-width: 1100px) {
    width: 0px;
  }
`;
export const ReImgDefault = styled.img`
  width: 100%;
  height: 100%;
`;

export const ReLoginMinuteText = styled.div`
  margin-top: 20px;
  font-size: 20px;
  width: 100%;
  z-index: 12;
  font-weight: 600;
  color: black;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
    1px 1px 0 #fff;

  @media (max-width: 1100px) {
    font-size: 18px;
  }

  @media (max-width: 900px) {
    font-size: 16px;
  }

  @media (max-width: 700px) {
    font-size: 16px;
  }
`;

export const ReLoginIconBox = styled.div`
  margin-right: 20px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  min-width: 50px;

  @media (max-width: 1100px) {
    width: 30px;
    min-width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  @media (max-width: 768px) {
    width: 20px;
    min-width: 20px;
    height: 20px;
    margin-right: 10px;
  }
`;

export const ReLoginBlackText = styled.div`
  color: black;
  font-size: 32px;
  font-weight: 800;
`;

export const ReLoginSizeBox = styled.div`
  width: ${({ $width }) => $width || "10px"};
  height: ${({ $height }) => $height || "10px"};
`;

export const ReLoginGraySpanText = styled.span`
  color: rgba(166, 173, 185, 1);
  text-decoration: underline;
  cursor: pointer;
`;

export const ReLoginFontWeight = styled.span`
  font-weight: 700;
`;

export const ResponsiveBr = styled.br`
  @media (max-width: 970px) {
    display: none;
  }
`;

export const ReLoginEndBoxText = styled.div`
  font-size: 20px;
  font-weight: 400;

  @media (max-width: 1300px) {
    font-size: 18px;
  }

  @media (max-width: 1200px) {
    font-size: 15px;
  }

  @media (max-width: 700px) {
    font-size: 14px;
  }

  @media (max-width: 576px) {
  }

  @media (max-width: 420px) {
  }

  @media (max-width: 360px) {
  }
`;

export const GrayLine = styled.div`
  background-color: #dededd;
  width: 100%;
  height: 1px;
`;
